<template>
    <div class="propertys-list w-100">
        <template v-for="props in sortedList">
            <template v-for="currentprop in props.properties">
                <template v-if="currentprop.id != 300">
                    <template v-if="currentprop.values.value">
                        <template v-if="currentprop.values.value.length > 30">
                            <div class="flex-fill d-flex w-100 py-2 cursor" data-toggle="collapse" :id="'heading_' + currentprop.id" :data-target="'#collapse_'+ currentprop.id" aria-expanded="false" :aria-controls="'collapse_'+ currentprop.id">
                                <div class="w-50 font-weight-bold">
                                    {{ currentprop.names.name }}
                                </div>
                                <div class="w-50 text-right">
                                    <i class="fa fa-plus"></i>
                                </div>
                            </div>
                            <div class="py-2 w-100 collapse" :id="'collapse_'+ currentprop.id" :data-parent="'.single-character'" v-html="currentprop.values.value"></div>
                        </template>
                        <template v-else>
                            <div class="flex-fill d-flex w-100 py-2">
                                <div class="w-50 font-weight-bold">
                                    {{ currentprop.names.name }}
                                </div>
                                <template v-if="currentprop.values.value">
                                    <div class="w-50" v-html="currentprop.values.value"></div>
                                </template>
                                <template v-else>
                                    <div class="w-50">&nbsp;</div>
                                </template>
                            </div>
                        </template>
                    </template>
                </template>
            </template>
        </template>
    </div>
</template>

<script>
    export default
    {
        props:
            {
                properties:
                    {
                        type: Array,
                        default: null
                    }
            },
        data: function()
        {
            return {

            }
        },
        mounted()
        {
           this.sortAll()
        },
        methods:
            {
                sortAll()
                {
                    this.properties.sort(this.compare)
                    for(let i=0; i< this.properties.length; i++)
                    {
                        this.properties[i].properties.sort(this.compare)
                    }
                },
                compare: function (a,b)
                {
                    if ( a.position < b.position ){
                        return -1;
                    }
                    if ( a.position > b.position ){
                        return 1;
                    }
                    return 0;
                }
            },
        computed:
            {

                sortedList:function()
                {
                    return this.properties;
                }
            }
    }
</script>
